import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import '@/styles/project-desk-mockup.css';
import '@/styles/project-desk.css';

/**
 * DP206 — the app's one confirm popup, in the desk's modal treatment. It
 * replaces window.confirm site by site (90 of them at the time of writing).
 *
 * Props: open, onOpenChange (as Dialog); title; message (one sentence);
 * actionLabel (the verb, e.g. "Delete decision"); onConfirm; destructive
 * (draws the action in brand red); busy (disables both buttons).
 */
export const KmConfirm = ({
  open,
  onOpenChange,
  title,
  message,
  actionLabel = 'Confirm',
  cancelLabel = 'Cancel',
  onConfirm,
  destructive = false,
  busy = false,
}) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="kpd-modal max-w-sm" data-testid="km-confirm">
      <DialogHeader>
        <DialogTitle className="kpd-modal__ttl">{title}</DialogTitle>
        {message && <DialogDescription className="kpd-modal__desc">{message}</DialogDescription>}
      </DialogHeader>
      <div className="kpd-acts kpd-modal__acts">
        <button
          type="button"
          onClick={() => onOpenChange?.(false)}
          disabled={busy}
          data-testid="km-confirm-cancel"
        >
          {cancelLabel}
        </button>
        <button
          type="button"
          className={destructive ? 'x' : 'k'}
          onClick={onConfirm}
          disabled={busy}
          data-testid="km-confirm-action"
        >
          {actionLabel}
        </button>
      </div>
    </DialogContent>
  </Dialog>
);

export default KmConfirm;
